<template>
  <div class="tourList">
    <div
      v-for="tour in tours"
      :key="tour.code"
    >
      <tour-cassette
        :tour="tour"
        :make-detail-page-url="makeDetailPageUrl(tour.sale_type)"
        :mobile="mobile"
        :duration-tabs="shouldShowTabsFor(tour)"
      />
    </div>
  </div>
</template>

<script>
import TourCassette from './TourCassette'

export default {
  name: 'TourList',
  components: {
    TourCassette,
  },
  props: {
    tours: {
      type: Array,
      required: true,
    },
    makeDetailPageUrl: {
      type: Function,  // saleType => tourCode => url
      required: true,
    },
    mobile: {
      type: Boolean,
      default: false,
    },
    durationTabs: {
      type: String,
      default: 'depends-on-sale-type',  // depends-on-sale-type: offline のツアーだけタブ表示、always: ツアー種別によらず表示
    },
  },
  methods: {
    shouldShowTabsFor(tour) {
      return this.durationTabs === 'always' || tour.sale_type === 'offline'
    },
  },
}
</script>

<style scoped lang="scss">
.tourList {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
</style>
